import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useUIStore } from '@/stores/uiStore';
import { clsx } from 'clsx';
import { NotificationCenter, ToastContainer } from '@/components/notifications';
import { useSignalRConnection, useUserNotifications } from '@/hooks/useSignalR';

export function MainLayout() {
  const { sidebarOpen, sidebarCollapsed } = useUIStore();

  // Initialize SignalR connection
  const { isConnected } = useSignalRConnection();

  // Listen for user-specific notifications
  useUserNotifications();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar */}
      <Sidebar />

      {/* Main content */}
      <div
        className={clsx(
          'transition-all duration-400',
          sidebarOpen
            ? sidebarCollapsed
              ? 'mr-70'
              : 'mr-260'
            : 'mr-0'
        )}
      >
        {/* Header */}
        <Header />

        {/* Page content */}
        <main className="p-6">
          <Outlet />
        </main>
      </div>

      {/* Real-time notifications */}
      <NotificationCenter />
      <ToastContainer />

      {/* SignalR connection indicator (dev only) */}
      {import.meta.env.DEV && (
        <div
          className={clsx(
            'fixed bottom-4 left-4 px-2 py-1 rounded text-xs font-mono',
            isConnected ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
          )}
        >
          SignalR: {isConnected ? 'Connected' : 'Disconnected'}
        </div>
      )}
    </div>
  );
}
